var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pippolo",style:({ backgroundColor: _vm.colors[_vm.colorIndex] }),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.loopColor}})}
var staticRenderFns = []

export { render, staticRenderFns }